import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Box, Center, Flex, Text, Link as ChakraLink, VStack, HStack } from '@chakra-ui/react';
import LoginFormContainer from '../LoginForm/LoginFormContainer';
import AuthTitle from '../AuthTitle';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recoveryMode: false,
    };
    this.onChangeMode = this.onChangeMode.bind(this);
  }

  onChangeMode() {
    this.setState((prevState) => ({
      recoveryMode: !prevState.recoveryMode,
    }));
  }

  renderLoginForm() {
    return (
      <div>
        <LoginFormContainer />
        <VStack spacing={3}>
          <ChakraLink onClick={this.onChangeMode}>
            <Text>Forgot your password?</Text>
          </ChakraLink>

          <Text mr={1}>
            Visit the{' '}
            <ChakraLink color="blue.500" href="https://radstar.accustarlabs.com/">
              <Text as={'span'} fontWeight={700}>
                Knowledge Base{' '}
              </Text>
            </ChakraLink>
            for full product instructions.
          </Text>

          <Text mr={1}> </Text>
        </VStack>
      </div>
    );
  }

  render() {
    const { recoveryMode } = this.state;

    return (
      <Choose>
        <When condition={recoveryMode}>
          <Redirect
            to={{
              pathname: `/forgot-password`,
            }}
          />
        </When>
        <Otherwise>
          <AuthTitle>
            <Center my={'30px'}>
              <Text mr={1}>Sign in below to manage your RadStar Alpha Reporting and test Results.</Text>
            </Center>
            <Flex w="100%" justifyContent={'center'}>
              <Box>{this.renderLoginForm()}</Box>
            </Flex>
          </AuthTitle>
        </Otherwise>
      </Choose>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// src/components/login/LoginPage/index.js